import { Pipe, PipeTransform } from '@angular/core';
import { abbreviateNumber } from '../../helpers';

@Pipe({
    name: 'numberAbbreviator',
    standalone: false
})
export class NumberAbbreviatorPipe implements PipeTransform {
    transform(value: number): string {
        return abbreviateNumber(value);
    }
}
